(() => {
  const mobile = window.matchMedia('(max-width: 799px)');
  const page = document.documentElement;
  let bars = [];
  let frame = 0;
  const update = () => {
    frame = 0;
    let clearance = 0;
    if (mobile.matches) {
      bars.forEach(bar => {
        if (bar.hidden) return;
        const rect = bar.getBoundingClientRect();
        if (rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight) {
          clearance = Math.max(clearance, Math.ceil(window.innerHeight - rect.top));
        }
      });
    }
    if (clearance) page.style.setProperty('--cv-mobile-buy-clearance', `${clearance}px`);
    else page.style.removeProperty('--cv-mobile-buy-clearance');
  };
  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(update);
  };
  const resize = new ResizeObserver(schedule);
  const changes = new MutationObserver(schedule);
  const bind = () => {
    resize.disconnect();
    changes.disconnect();
    bars = [...document.querySelectorAll('[data-sticky-buy]')];
    bars.forEach(bar => {
      resize.observe(bar);
      changes.observe(bar, {attributes: true, attributeFilter: ['hidden', 'class', 'style']});
    });
    schedule();
  };
  mobile.addEventListener('change', schedule);
  window.addEventListener('resize', schedule, {passive: true});
  window.visualViewport?.addEventListener('resize', schedule, {passive: true});
  document.addEventListener('shopify:section:load', bind);
  document.addEventListener('shopify:section:unload', bind);
  bind();
})();
